import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ISharedAreaState } from '../../../shared-area.module';
import { ObjektTyp } from 'app/core/services/api-client';

export const getSharedAreaState = createFeatureSelector<ISharedAreaState>('shared');

export const getUserProfileState = createSelector(
  getSharedAreaState,
  (shared: ISharedAreaState) => shared.userProfile
);

export const getUserProfileApiState = createSelector(
  getUserProfileState,
  state => state.apiState
);

export const getFachlektorMerkmale = createSelector(
  getUserProfileState,
  state => state.fachlektorMerkmale
);

export const getLieferantenMerkmale = createSelector(
  getUserProfileState,
  state => state.lieferantenMerkmale
);

export const getFavouriteMerkmale = createSelector(
  getUserProfileState,
  state => state.favouriteMerkmale
);

export const getFavoriten = createSelector(
  getUserProfileState,
  state => state.favoriten || []
);

export const isFavoritenLoading = createSelector(
  getUserProfileState,
  state => state.isFavoritenLoading
);

export const isCheckingFavorit = createSelector(
  getUserProfileState,
  state => state.isCheckingFavorit
);

export const isFavorite = (objektTyp: ObjektTyp, objektId: number) =>
  createSelector(
    getFavoriten,
    favoriten =>
      favoriten.some(f => f.objektId === objektId && f.objektTyp === objektTyp)
  );
